import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import {AutomationCreateStepEnum, AutomationTypeEnum, OverviewSortOptionEnum, RunIntervalEnum,} from "../enums";
import {CategoryEnum, TaskTypeEnum} from "~/enums";
import TaskPriorityEnum from "../../../enums/TaskPriorityEnum";

const state = {
  automationActions: [],
  fetchingAutomationActions: false,
  automations: [],
  unconfiguredGlobalAutomations: [],
  selectedAutomationResults: [],
  creatingAutomation: {
    automation_action_id: undefined,
    search_id: undefined,
    dynamic_extending_search_ids: [],
    title: undefined,
    description: undefined,
    run_interval: RunIntervalEnum.NEVER,
    is_recurring: false,
    temporary_exclude_recurring: false,
    temporary_exclude_recurring_duration: {
      days: undefined,
      weeks: undefined,
      months: undefined,
      year: undefined,
    },
    auto_process: false,
    needs_verification: false,
    visible_in_customer_portal: false,

    // signal
    create_signal: false,
    signal_title: null,
    signal_description: null,
    signal_assigned_users: [],
    signal_assigned_departments: [],
    signal_auto_process: false,
    signal_process_after: 0,

    // email campaign
    send_email: false,
    email_subject: null, // ?
    email_template_id: undefined,
    html_email_template_id: undefined,
    send_email_at_office_hours: true,
    email_account_id: undefined,

    // task settings
    create_task: false,
    task_type: TaskTypeEnum.GENERAL_TASK,
    task_title: null,
    task_description: null,
    task_priority: TaskPriorityEnum.NORMAL,
    task_category: CategoryEnum.CUSTOMER,
    task_assigned_users: [],
    task_assigned_user_departments: [],
    task_assigned_product_labels: [],
    task_selected_template: [],
  },
  fetchingAutomations: false,
  fetchingCategories: false,
  fetchingUsers: false,
  fetchingUserDepartments: false,
  fetchingTaskTemplates: false,
  fetchingAutomationResults: false,
  automationResults: [],
  automationResultsPagination: {
    page: 1,
    perPage: 15,
  },
  fetchingMe: false,
  users: [],
  userDepartments: [],
  categories: [],
  me: null,
  taskTemplates: [],
  globalAutomations: [],
  fetchingGlobalAutomations: false,
  fetchingUnconfiguredGlobalAutomations: false,
  globalSearches: [],
  fetchingGlobalSearches: false,
  searches: [],
  fetchingSearches: false,
  extendingSearches: [],
  fetchingExtendingSearches: false,
  dynamicExtendingSearches: [],
  fetchingDynamicExtendingSearches: false,
  selectedAutomation: null,
  selectedCampaign: null,
  selectedGlobalAutomationConfiguration: null,
  selectedAutomationActionId: undefined,
  ignoredAutomationResults: [],
  selectedGlobalAutomationId: undefined,
  selectedSearchId: undefined,
  selectedExtendingSearchesIds: [],
  selectedDynamicExtendingSearchesIds: [],
  processType: AutomationTypeEnum.DATA_ENRICHMENT,
  activeStep: AutomationCreateStepEnum.PROCESS,
  showResultConfirmModal: false,
  filterLoaded: false,
  defaultFilter: {
    type: null,
    searchModelType: null,
    actionType: [],
    automationName: null,
    customers: [],
    activeAutomations: 1,
    inactiveAutomations: 1,
    onceAutomations: 1,
  },
  filter: {},
  activeAutomationables: [],
  inactiveAutomationables: [],
  onceAutomationables: [],
  loadingOnceAutomationables: false,
  loadingActiveAutomationables: false,
  loadingInactiveAutomationables: false,
  formDirty: true,
  pendingConfirmationCount: 0,

  // sorting
  selectedSortingCategory: OverviewSortOptionEnum.ACTIVE,
  showEmailAutomations: true,
  showSignalAutomations: true,
  showTaskAutomations: true,
  searchQuery: "",
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
